<template>
  <div>
    <div class="serviceContent">
      <div style="overflow:hidden" class="serviceTitle">
        <div class="content">
          <div class="thumb">
            <i class="iconfont iconhome"></i>
            <span>主页</span>
            <i class="iconfont iconyou"></i>
            <span @click="goBack()">企业发布</span>
            <i class="iconfont iconyou"></i>
            <span>研发服务</span>
          </div>
          <div style="margin-top:10px">
            <img src="../../public/images/serviceInfo/enterpriseTitle.jpg" />
          </div>
        </div>
      </div>
      <div class="content">
        <div class="enterpriseContent">
          <div class="enterpriseLeft">
            <div class="info1" style="display: flex;">
              <div style="flex:0.8">
                <h1>{{enterpriseInfo.serviceType}}</h1>
                <div style="width: 45px;height: 3px;background-color: #5fccff;margin-top:15px"></div>
                <p
                  style="color:#4b4b4b;font-size: 20px;margin:10px 0px"
                >{{enterpriseInfo.serviceName}}</p>
                <p style="color:#4b4b4b;font-size: 22px">
                  有效期：
                  <span style="color:#5fccff">{{enterpriseInfo.serviceDate}}</span>
                </p>
              </div>
              <div style="flex:0.2">
                <div class="relation">
                  <p>联系电话</p>
                </div>
              </div>
            </div>
            <div class="info2">
              <h1>
                <span></span>需求信息
              </h1>
              <p>
                评分要求：
                <img src="../../public/images/serviceInfo/star.jpg" />
              </p>
              <p>熟练程度：{{enterpriseInfo.proficiency}}</p>
              <p>学历要求：{{enterpriseInfo.education}}</p>
              <p>年龄要求：{{enterpriseInfo.age}}</p>
              <p>性别要求：{{enterpriseInfo.sex}}</p>
              <h1>
                <span></span>职责描述
              </h1>
              <p style="margin-bottom:0px">{{enterpriseInfo.describe}}</p>
            </div>
            <div class="info3">
              <h1>
                <span></span>已报名
              </h1>
              <div
                style="display: flex;justify-content: space-between;border-bottom: 1px #ccc dashed;margin:10px 0px;padding-bottom:10px"
              >
                <div>
                  <p>张*</p>
                  <div style="margin:5px 0px;position:relative">
                    评分
                    <img
                      src="../../public/images/serviceInfo/star.jpg"
                      style="left: 40px;top: -5px;position: absolute;"
                    />
                  </div>
                  <p>熟练程度：一般</p>
                </div>
                <div style="margin-right: 100px;">
                  <p>张*</p>
                  <div style="margin:5px 0px;position:relative">
                    评分
                    <img
                      src="../../public/images/serviceInfo/star.jpg"
                      style="left: 40px;top: -5px;position: absolute;"
                    />
                  </div>
                  <p>熟练程度：一般</p>
                </div>
              </div>
              <div
                style="display: flex;justify-content: space-between;border-bottom: 1px #ccc dashed;margin:10px 0px;padding-bottom:10px"
              >
                <div>
                  <p>张*</p>
                  <div style="margin:5px 0px;position:relative">
                    评分
                    <img
                      src="../../public/images/serviceInfo/star.jpg"
                      style="left: 40px;top: -5px;position: absolute;"
                    />
                  </div>
                  <p>熟练程度：一般</p>
                </div>
                <div style="margin-right: 100px;">
                  <p>张*</p>
                  <div style="margin:5px 0px;position:relative">
                    评分
                    <img
                      src="../../public/images/serviceInfo/star.jpg"
                      style="left: 40px;top: -5px;position: absolute;"
                    />
                  </div>
                  <p>熟练程度：一般</p>
                </div>
              </div>
            </div>
          </div>
          <div class="enterpriseRight">
            <div class="enterprise">
              <h1>{{enterpriseInfo.serviceCompany}}</h1>
              <p>注册资本：{{enterpriseInfo.registered}}</p>
              <p>服务区域：{{enterpriseInfo.serviceArea}}</p>
              <p>成立日期：{{enterpriseInfo.setup}}</p>
            </div>
            <img src="../../public/images/serviceInfo/enterpriseContent.jpg" />
            <div class="info">
              <p class="title">浏览了该帖子的人还浏览了……</p>
              <div class="enterpriseInfo">
                <h1>工程探勘服务</h1>
                <span style="width: 30px;height: 4px;background: #5fccff;display:inline-block;"></span>
                <p>
                  有效期：
                  <span>2020-09-15</span>
                </p>
              </div>
              <div class="enterpriseInfo">
                <h1>工程探勘服务</h1>
                <span style="width: 30px;height: 4px;background: #5fccff;display:inline-block;"></span>
                <p>
                  有效期：
                  <span>2020-09-15</span>
                </p>
              </div>
              <div class="enterpriseInfo">
                <h1>工程探勘服务</h1>
                <span style="width: 30px;height: 4px;background: #5fccff;display:inline-block;"></span>
                <p>
                  有效期：
                  <span>2020-09-15</span>
                </p>
              </div>
              <div class="enterpriseInfo" style="border:none">
                <h1>工程探勘服务</h1>
                <span style="width: 30px;height: 4px;background: #5fccff;display:inline-block;"></span>
                <p>
                  有效期：
                  <span>2020-09-15</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Nav :message="scroll"></Nav>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/nav";
import Footer from "../components/footer";
export default {
  data () {
    return {
      scroll: '1',
      enterpriseInfo: {}
    }
  },
  created () {
    this.enterpriseInfo = JSON.parse(this.$route.query.data)
  },
  mounted () {
    window.scrollTo(0, 0);
  },
  methods: {
    goBack () {
      this.$router.push({
        path: '/market',
        query: { data: 1 }
      })
    }
  },
  components: {
    Nav,
    Footer,
  },
}
</script>

<style scoped>
.thumb {
  margin-top: 30px;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 5px;
  color: #515151;
  font-size: 13px;
}
.thumb > span {
  padding: 0 10px;
}
.serviceContent {
  background: #f1f3f8;
  width: 100%;
  padding-bottom: 50px;
  padding-top: 106px;
  overflow: hidden;
}
/* 中心内容区 */
.enterpriseContent {
  display: flex;
  margin-top: 8px;
}

.enterpriseContent .enterpriseLeft {
  width: 100%;
  margin-right: 10px;
  background: #f1f3f8;
}
.enterpriseLeft .info1,
.info3 {
  padding: 35px 60px 47px 45px;
  background: #ffffff;
}
.enterpriseLeft .info1 h1 {
  font-family: "SimHei";
  font-size: 42px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 25px;
  letter-spacing: 0px;
  color: #4b4b4b;
}
.enterpriseLeft .info1 .relation {
  width: 193px;
  height: 65px;
  background-color: #5fccff;
  box-shadow: 0px 2px 1px 0px rgba(0, 8, 34, 0.25);
  margin-top: 40px;
  cursor: pointer;
}
.enterpriseLeft .info1 .relation p {
  text-align: center;
  color: #ffffff;
  font-size: 26px;
  line-height: 65px;
}
.enterpriseLeft .info2 {
  padding: 30px 50px;
  background: #ffffff;
  margin-bottom: 14px;
}
.enterpriseLeft .info2 span,
.info3 span {
  width: 6px;
  height: 20px;
  background-color: #5fccff;
  display: inline-block;
  margin-right: 5px;
}
.enterpriseLeft .info2 h1,
.info3 h1 {
  font-size: 30px;
  font-weight: bold;
}
.enterpriseLeft .info2 p {
  font-size: 20px;
  color: #4b4b4b;
  margin: 20px 0px;
}

.enterpriseContent .enterpriseRight {
  background: #f1f3f8;
  cursor: pointer;
  width: 450px;
}
.enterpriseRight .enterprise {
  background: #ffffff;
  padding: 35px 65px 6px 50px;
  margin-bottom: 10px;
}
.enterpriseRight .enterprise h1 {
  font-size: 30px;
  font-weight: bold;
}
.enterpriseRight .enterprise p {
  color: rgb(75, 75, 75);
  font-size: 20px;
  margin: 10px 0px;
}
.enterpriseRight .info {
  margin-top: 10px;
  padding: 32px 25px 0px 30px;
  background: #ffffff;
}
.enterpriseRight .info .title {
  padding-bottom: 25px;
  border-bottom: 1px #cccc solid;
  font-size: 24px;
}
.enterpriseRight .info .enterpriseInfo {
  margin-top: 30px;
  padding-right: 20px;
  padding-bottom: 30px;
  border-bottom: dashed 1px #ccc;
}
.enterpriseRight .info .enterpriseInfo h1 {
  font-size: 30px;
  font-weight: bold;
  width: 100%;
}
</style>